var _circle, _mask, _path, _mask2, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoBuildingsElevation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 184,
    cy: 184,
    r: 13.5,
    stroke: "#808080",
    strokeWidth: 3
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_1144_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199 184C199 182.03 198.612 180.08 197.858 178.26C197.104 176.44 195.999 174.786 194.607 173.393C193.214 172.001 191.56 170.896 189.74 170.142C187.92 169.388 185.97 169 184 169L184 184H199Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M199 184C199 182.03 198.612 180.08 197.858 178.26C197.104 176.44 195.999 174.786 194.607 173.393C193.214 172.001 191.56 170.896 189.74 170.142C187.92 169.388 185.97 169 184 169L184 184H199Z",
    fill: "#808080",
    stroke: "#808080",
    strokeWidth: 6,
    mask: "url(#path-2-inside-1_1144_2)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_1144_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169 184C169 185.97 169.388 187.92 170.142 189.74C170.896 191.56 172.001 193.214 173.393 194.607C174.786 195.999 176.44 197.104 178.26 197.858C180.08 198.612 182.03 199 184 199L184 184H169Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M169 184C169 185.97 169.388 187.92 170.142 189.74C170.896 191.56 172.001 193.214 173.393 194.607C174.786 195.999 176.44 197.104 178.26 197.858C180.08 198.612 182.03 199 184 199L184 184H169Z",
    fill: "#808080",
    stroke: "#808080",
    strokeWidth: 6,
    mask: "url(#path-3-inside-2_1144_2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 95.0619V185C3 190.523 7.47715 195 13 195H77H141C146.523 195 151 190.523 151 185V95.0619C151 92.6754 150.146 90.3675 148.594 88.5553L84.5937 13.8624C80.6026 9.20455 73.3974 9.20455 69.4063 13.8624L5.40631 88.5553C3.8535 90.3675 3 92.6754 3 95.0619Z",
    stroke: "black",
    strokeWidth: 6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoBuildingsElevation);
export default __webpack_public_path__ + "static/media/ico_buildings_elevation.3d5efb42e52db81d9bdb880c0f31ce1a.svg";
export { ForwardRef as ReactComponent };